//import Main from '@/views/Main.vue'
import Mec from '@/views/Mec.vue'
import Main from '@/views/Main.vue'
import Personage from '@/views/user/center.vue'
import Entrance from '@/views/personal/entrance.vue'
import Login from '@/views/Login.vue'
import RegisterInfo from '@/views/user/registerInfo.vue'
import shortcutOrder from '@/views/shortcut/shortcutOrder.vue'
import QuestionnaireReport from '@/views/appointment/questionnaireReport.vue'
import AppointmentProject from '@/views/appointment/project.vue'
import AppointmentConfirm from '@/views/appointment/confirm.vue'
import AppointmentSubmit from '@/views/appointment/submit.vue'
import NotFoundComponent from '@/components/common/NotFoundComponent.vue'

/**
 * 关于路由匹配优先级
 * 有时候，同一个路径可以匹配多个路由，此时，匹配的优先级就按照路由的定义顺序：谁先定义的，谁的优先级就最高。
 * 例如: 路由A=/home 路由B=/:type ,如果定义顺序为A,B,则路由A访问正常,如果定义顺序为B,A,则访问/home会执行路由B
 */

export default [
  {
    path: '/',
    redirect: '/main'
  },
  {
    name: 'main', // 主页
    path: '/main',
    meta: {
      title: '51健康体检专家',
      grade: 1,
      hiddenHead: true,
      showTab: true
    },
    component: Main
  },

  {
    name: 'personage', // 个人中心
    path: '/personage',
    meta: {
      title: '个人中心',
      grade: 3,
      hiddenHead: true,
      showTab: true
    },
    component: Personage
  },
  {
    name: 'personageDetail', // 用户信息
    path: '/personage/detail',
    meta: {
      title: '用户信息'
      // hiddenHead: true,
      // showTab: true
    },
    component: () => import('@/views/user/detail.vue')
  },
  {
    name: 'oldEdit', // 老版本修改密码
    path: '/edit/oldPsw',
    meta: {
      title: '修改密码'
      // hiddenHead: true,
      // showTab: true
    },
    component: () => import('@/views/user/oldEditPsw.vue')
  },
  {
    name: 'newEdit', // 修改密码
    path: '/edit/newPsw',
    meta: {
      title: '修改密码'
      // hiddenHead: true,
      // showTab: true
    },
    component: () => import('@/views/user/newEditPsw.vue')
  },
  {
    name: 'editSucceed', // 修改密码成功
    path: '/edit/succeed',
    meta: {
      title: '修改密码'
    },
    component: () => import('@/views/user/editSucceed.vue')
  },
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  /****************** 首页 -- 体检预约 *********************/
  {
    name: 'entrance', // 体检预约
    path: '/entrance',
    meta: {
      title: '个性化体检预约',
      hiddenHead: true,
      menuBar: true
    },
    component: Entrance
  },
  {
    name: 'introduce', // 了解检前问诊
    path: '/introduce',
    meta: {
      title: '检前问诊简介',
      hiddenHead: true,
      menuBar: true
    },
    component: () => import('@/views/personal/introduce.vue')
  },
  {
    name: 'registerInfo', // 登记信息
    path: '/registerInfo/:source',
    meta: {
      title: '核对和完善信息'
    },
    component: RegisterInfo
  },
  {
    name: 'shortcutOptPlan', // 确认方案
    path: '/shortcut/order/optPlan/:sysCenterId/:id',
    meta: {
      title: '确认方案'
    },
    component: () => import('@/views/shortcut/optPlan.vue')
  },
  {
    name: 'shortcutOrderSuccess', // 预约成功
    path: '/shortcut/order/success/:sysCenterId/:id',
    meta: {
      title: '预约成功'
    },
    component: () => import('@/views/shortcut/success.vue')
  },
  {
    name: 'shortcutOrder', // 登记信息
    path: '/shortcut/order',
    meta: {
      title: '快速预约通道'
    },
    component: shortcutOrder
  },
  {
    name: 'questionnaireReport', // 个人 -- 体检报告
    path: '/questionnaireReport',
    meta: {
      hiddenHead: true
    },
    component: QuestionnaireReport
  },
  {
    name: 'appointmentProject', // 体检预约自选项目
    path: '/appointment/project/:type',
    meta: {
      title: '自选体检项目',
      hiddenHead: true
    },
    component: AppointmentProject
  },
  {
    name: 'appointmentConfirm', // 体检预约自选项目
    path: '/appointment/confirm/:type/:id', // type=customize id为个体化问诊实例ID,type=product id=productId
    meta: {
      title: '确认体检项目',
      hiddenHead: true
    },
    component: AppointmentConfirm
  },
  {
    name: 'appointmentSubmit', // 体检预约提交订单
    path: '/appointment/submit',
    meta: {
      title: '体检预约',
      hiddenHead: true
    },
    component: AppointmentSubmit
  },
  {
    name: 'order', // 订单列表
    path: '/order',
    meta: {
      title: '订单列表',
      showTab: true,
      menuBar: false
    },
    component: () => import('@/views/order/index.vue')
  },

  {
    name: 'modifyOrder', // 订单详情
    path: '/order/personal/modify/:id',
    meta: {
      title: '修改订单'
    },
    component: () => import('@/views/order/personal/modify.vue')
  },
  {
    name: 'personalOrder', // 订单详情
    path: '/order/personal/:sysCenterId/:id',
    meta: {
      menuBar: true,
      title: '订单详情'
    },
    component: () => import('@/views/order/personal/index.vue')
  },
  {
    name: 'onlinePayment', // 体检攻略 (在线支付)
    path: '/order/onlinePayment/:type/:id',
    meta: {
      // menuBar: true,
      title: '体检攻略'
    },
    component: () => import('@/views/order/onlinePayment.vue')
  },
  {
    name: 'refundApply', // 申请退款
    path: '/refund/apply',
    meta: {
      // menuBar: true,
      title: '退款申请'
    },
    component: () => import('@/views/refund/apply.vue')
  },
  {
    name: 'refundDetail', // 退款详情
    path: '/refund/detail',
    meta: {
      // menuBar: true,
      title: '退款详情'
    },
    component: () => import('@/views/refund/detail.vue')
  },
  {
    name: 'refundSucceed', // 退款成功
    path: '/refund/succeed',
    meta: {
      // menuBar: true,
      title: '退款详情'
    },
    component: () => import('@/views/refund/succeed.vue')
  },
  // {
  //   name: 'chooseHospital', // 选择体检中心
  //   path: '/chooseHospital',
  //   meta: {
  //     hiddenHead: true
  //   },
  //   component: () => import('@/views/personal/team/chooseHospital.vue')
  // },
  // {
  //   name: 'order', // 订单列表
  //   path: '/order',
  //   meta: {
  //     title: '我的订单',
  //     showTab: true
  //   },
  //   component: () => import('@/views/order/orderList/orderList.vue'),
  //   children: [
  //     {
  //       name: 'orderDoing', //预约信息
  //       path: 'orderDoing',
  //       meta: {
  //         title: '我的订单',
  //         showTab: true
  //       },
  //       component: () => import('@/views/order/orderList/orderDoing.vue')
  //     },
  //     {
  //       name: 'orderAll', //体检须知
  //       path: 'orderAll',
  //       meta: {
  //         title: '我的订单',
  //         showTab: true
  //       },
  //       component: () => import('@/views/order/orderList/orderAll.vue')
  //     }
  //   ]
  // },
  // {
  //   name: 'orderDetail', // 订单详情
  //   path: '/orderDetail',
  //   meta: {
  //     title: '订单详情'
  //   },
  //   component: () => import('@/views/order/orderDetail/orderDetail.vue'),
  //   children: [
  //     {
  //       name: 'bookingInfo', //预约信息
  //       path: 'bookingInfo',
  //       meta: {
  //         title: '订单详情'
  //       },
  //       component: () => import('@/views/order/orderDetail/bookingInfo.vue')
  //     },
  //     {
  //       name: 'medicalGuide', //体检须知
  //       path: 'medicalGuide',
  //       meta: {
  //         title: '订单详情'
  //       },
  //       component: () => import('@/views/order/orderDetail/medicalGuide.vue')
  //     },
  //     {
  //       name: 'traffic', //交通导航
  //       path: 'traffic',
  //       meta: {
  //         title: '订单详情'
  //       },
  //       component: () => import('@/views/order/orderDetail/traffic.vue')
  //     }
  //   ]
  // },
  /***************** 个人中心 - 团队体检 *********************/
  // {
  //   name: 'checkList', // 团检列表
  //   path: '/checkList',
  //   meta: {
  //     title: '我的团检订单'
  //   },
  //   component: () => import('@/views/personal/team/checkList.vue')
  // },
  // {
  //   name: 'orderDetail', // 订单详情
  //   path: '/orderDetail',
  //   meta: {
  //     title: '订单详情'
  //   },
  //   component: () => import('@/views/personal/team/orderDetail/orderDetail.vue'),
  //   children: [
  //     {
  //       name: 'bookingInfo', //预约信息
  //       path: 'bookingInfo',
  //       component: () => import('@/views/personal/team/orderDetail/bookingInfo.vue')
  //     },
  //     {
  //       name: 'medicalGuide', //体检须知
  //       path: 'medicalGuide',
  //       component: () => import('@/views/personal/team/orderDetail/medicalGuide.vue')
  //     },
  //     {
  //       name: 'traffic', //交通导航
  //       path: 'traffic',
  //       component: () => import('@/views/personal/team/orderDetail/traffic.vue')
  //     }
  //   ]
  // },
  // {
  //   name: 'confirmMedical', // 确认已完成此次医院体检
  //   path: '/confirmMedical',
  //   meta: {
  //     hiddenHead: true,
  //     title: '确认体检'
  //   },
  //   component: () => import('@/views/personal/team/confirmMedical.vue')
  // },
  // {
  //   name: 'confirmOrder', // 确认订单
  //   path: '/confirmOrder',
  //   meta: {
  //     title: '确认团检订单'
  //   },
  //   component: () => import('@/views/personal/team/confirmOrder.vue')
  // },
  // {
  //   name: 'persInfo', // 确认个人信息
  //   path: '/persInfo',
  //   meta: {
  //     title: '核对和完善信息'
  //   },
  //   component: () => import('@/views/personal/team/persInfo.vue')
  // },
  // {
  //   name: 'confirmProject', // 确认项目
  //   path: '/confirmProject',
  //   meta: {
  //     title: '确认项目'
  //   },
  //   component: () => import('@/views/personal/team/confirmProject.vue')
  // },
  // {
  //   name: 'addProject', // 自选--添加项目
  //   path: '/addProject',
  //   meta: {
  //     title: '更多体检项目'
  //   },
  //   component: () => import('@/views/personal/team/addProject.vue')
  // },
  // {
  //   name: 'confirmDate', // 确认日期
  //   path: '/confirmDate',
  //   component: () => import('@/views/personal/team/confirmDate.vue')
  // },
  {
    name: 'orderVerify', // 预约审核
    path: '/order/verify',
    meta: {
      title: '订单结果',
      hiddenHead: true
    },
    component: () => import('@/views/order/personal/verify.vue')
  },
  {
    name: 'orderSucceed', // 预约成功
    path: '/order/succeed',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/order/personal/succeed.vue')
  },
  // {
  //   name: 'inquiry', //问诊-首页
  //   path: '/inquiry',
  //   meta: {
  //     title: '检前问诊'
  //   },
  //   component: () => import('@/views/personal/team/inquiry.vue')
  // },
  {
    name: 'physicalQuestionnaire', //问诊-zj
    path: '/physicalQuestionnaire/:source',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/personal/physicalQuestionnaire.vue')
  },
  {
    name: 'illnessQuestionnaire', //专病问卷-zj
    path: '/illnessQuestionnaire/:id/:instanceId/:source',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/illness/illnessQuestionnaire.vue')
  },
  {
    name: 'questionDetails', //问诊-问卷报告
    path: '/questionDetails/:source/:instanceId',
    meta: {
      title: '问诊信息',
      hiddenHead: true
    },
    component: () => import('@/views/personal/questionDetails.vue')
  },

  {
    name: 'physicalExamination', //体检情况
    path: '/physicalExamination/:instanceId/:source',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/personal/physicalExamination.vue')
  },
  {
    name: 'physicalScheme', //体检情况   男：b   女：a  /  已婚(含同居)：b   未婚：a
    path: '/physicalScheme/:instanceId/:marryStateCode/:age/:sexCode',
    meta: {
      title: '问诊推荐体检方案',
      hiddenHead: true
    },
    component: () => import('@/views/personal/physicalScheme.vue')
  },
  {
    name: 'productList', //体检套餐列表
    path: '/product/list',
    meta: {
      title: '体检套餐',
      hiddenHead: true,
      menuBar: true,
      keepAlive: true
    },
    component: () => import('@/views/product/list.vue')
  },
  {
    name: 'productDetail', //体检套餐详情
    path: '/product/detail/:productId',
    meta: {
      title: '查看套餐详情',
      menuBar: true,
      hiddenHead: true
    },
    component: () => import('@/views/product/detail.vue')
  },

  // {
  //   name: 'medicalAdvice', //体检建议
  //   path: '/medicalAdvice',
  //   meta: {
  //     hiddenHead: true
  //   },
  //   component: () => import('@/views/personal/team/medicalAdvice.vue')
  // },
  // {
  //   name: 'changeSchemes', //更换体检方案
  //   path: '/changeSchemes',
  //   meta: {
  //     title: '更换体检方案'
  //   },
  //   component: () => import('@/views/personal/team/changeSchemes.vue')
  // },

  {
    name: 'newsList',
    path: '/news/list',
    meta: {
      title: '健康资讯',
      menuBar: true
    },
    component: () => import('@/views/news/List.vue')
  },
  {
    name: 'newsDetail',
    path: '/news/:id',
    meta: {
      title: '查看资讯详情',
      menuBar: true
    },
    component: () => import('@/views/news/Detail.vue')
  },

  {
    name: 'onlineCommunicationList',
    path: '/onlineCommunication/list',
    meta: {
      title: '在线沟通',
      menuBar: false
    },
    component: () => import('@/views/onlineCommunication/list.vue')
  },
  {
    name: 'communicationHealth',
    path: '/onlineCommunication/health/list',
    meta: {
      title: '健康顾问在线',
      menuBar: false
    },
    component: () => import('@/views/onlineCommunication/health/list.vue')
  },
  {
    name: 'communicationAdvise',
    path: '/onlineCommunication/advise/linkUp/:centerId',
    meta: {
      title: '投诉与建议',
      menuBar: false
    },
    component: () => import('@/views/onlineCommunication/advise/linkUp.vue')
  },
  {
    name: 'communicationSuggestQurstion',
    path: '/onlineCommunication/suggest/question',
    meta: {
      title: '满意度调查',
      menuBar: false
    },
    component: () => import('@/views/onlineCommunication/suggest/question.vue')
  },
  {
    name: 'communicationReport',
    path: '/onlineCommunication/report/list',
    meta: {
      title: '体检报告咨询',
      menuBar: false
    },
    component: () => import('@/views/onlineCommunication/report/list.vue')
  },
  {
    name: 'consultList',
    path: '/consult/list',
    meta: {
      menuBar: true
    },
    component: () => import('@/views/consult/list.vue')
  },
  {
    name: 'consultService',
    path: '/consult/service/:id',
    meta: {
      menuBar: true
    },
    component: () => import('@/views/consult/Service.vue')
  },
  {
    name: 'consultVirus',
    path: '/consult/virus',
    meta: {
      menuBar: false
    },
    component: () => import('@/views/consult/virus.vue')
  },
  {
    name: 'consultFeedback',
    path: '/consult/feedback/:id',
    component: () => import('@/views/consult/Feedback.vue')
  },
  {
    name: 'about',
    path: '/about',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/About.vue')
  },
  {
    name: 'mec',
    path: '/mec/:id',
    component: Mec
  },
  {
    name: 'mecGuidelines',
    path: '/mec/guidelines',
    meta: {
      menuBar: true
    },
    component: () => import('@/views/center/guidelines.vue')
  },
  {
    name: 'mecPersonalCenter',
    path: '/personalCenter',
    meta: {
      menuBar: true
    },
    component: () => import('@/views/center/personalCenter.vue')
  },
  //服务卡
  {
    name: 'card',
    path: '/card',
    meta: {
      title: '在线测评',
      hiddenHead: true,
      menuBar: true
    },
    component: () => import('@/views/card/publicity.vue')
  },
  { //购买服务卡
    name: 'purchaseCard',
    path: '/purchaseCard',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/merchandise/purchase.vue')
  },
  { //购买服务卡填写信息
    name: 'purchaseCardRegister',
    path: '/purchaseCard/register',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/merchandise/purchaseRegisterInfo.vue')
  },
  { //购买服务卡支付页面
    name: 'purchasePay',
    path: '/purchaseCard/payCard',
    meta: {
      title: '在线支付',
      hiddenHead: true
    },
    component: () => import('@/views/merchandise/payCard.vue')
  },
  { //购买服务卡支付页面 二维码
    name: 'purchasePayQrCode',
    path: '/purchaseCard/QrCode',
    meta: {
      title: '在线支付',
      hiddenHead: true
    },
    component: () => import('@/views/merchandise/qrCodePay.vue')
  },
  { //购买服务卡支付 成功页面
    name: 'purchaseCardPaySuccess',
    path: '/purchaseCard/Success',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/merchandise/success.vue')
  },
  { //服务卡扫描激活
    name: 'enableCard',
    path: '/enableCard',
    meta: {
      menuBar: true,
      hiddenHead: true
    },
    component: () => import('@/views/card/enableCard.vue')
  },
  { //服务卡个人信息
    name: 'registerInfoCard',
    path: '/registerInfoCard',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/card/registerInfo.vue')
  },
  { //服务卡个人信息
    name: 'addCardUserMsg',
    path: '/card/userMsg/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/card/addCardMsg.vue')
  },
  { //服务卡激活成功
    name: 'successCard',
    path: '/successCard/:cardId',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/card/success.vue')
  },
  { //服务卡激活成功
    name: 'serveCard',
    path: '/serveCard/:cardId',
    meta: {
      title: '健康服务',
      menuBar: true,
      hiddenHead: true
    },
    component: () => import('@/views/card/serveCard.vue')
  },
  { //服务卡未做完项目
    name: 'assessList',
    path: '/assessList/:cardId',
    meta: {
      menuBar: true,
      hiddenHead: true
    },
    component: () => import('@/views/card/assessList.vue')
  },
  { //服务卡问卷查看
    name: 'checkQuestionCard',
    path: '/checkQuestionCard/:cardId',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/card/checkQuestion.vue')
  },
  { //服务卡问卷回答
    name: 'cardQuestions',
    path: '/cardQuestions/:cardId',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/card/question.vue')
  },
  { //服务卡列表
    name: 'cardList',
    path: '/cardList',
    meta: {
      title: '我的卡包',
      menuBar: true,
      hiddenHead: true
    },
    component: () => import('@/views/card/list.vue')
  },
  { //服务卡购买记录
    name: 'cardFormation',
    path: '/userInformation',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/card/userInformation.vue')
  },
  { //团检企业专场
    name: 'teamFirmOrde',
    path: '/team/firmOrde',
    meta: {
      title: '企业体检专区',
      menuBar: true,
      hiddenHead: true
    },
    component: () => import('@/views/team/firmOrde.vue')
  },
  { //团检列表
    name: 'teamList ',
    path: '/team/list',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/list.vue')
  },
  { //团检列表
    name: 'teamList ',
    path: '/team/list',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/list.vue')
  },
  { //确认团检订单
    name: 'teamOrderSearch',
    path: '/team/orderSearch',
    meta: {
      title: '查找团检订单',
      hiddenHead: true
    },
    component: () => import('@/views/team/search.vue')
  },
  { //确认团检订单     bus  (1:个检 ， 2：套餐 ， 3：自选 ， 4：服务卡 ， 5 团检)
    name: 'allRegisterInfo',
    path: '/team/registerInfo/:bus',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/registerInfo.vue')
  },
  { //确认团检订单
    name: 'teamAffirm',
    path: '/team/affirm/:id',
    meta: {
      title: '确认团检',
      hiddenHead: true
    },
    component: () => import('@/views/team/affirm.vue')
  },
  { //开始登记
    name: 'teamStart',
    path: '/team/start/:bus',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/start.vue')
  },
  { //问卷填写
    name: 'teamQuestion',
    path: '/team/question/:bus',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/question.vue')
  },
  { //问卷详情
    name: 'teamQuestionDetails',
    path: '/team/questionDetails/:s/:bus', //s:source  1 ：正常流程（问卷来）     2：填写信息（查询上一次问卷得来）  3：专病来
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/questionDetails.vue')
  },
  { //团检选项目
    name: 'teamProjectConfirm',
    path: '/team/projectConfirm',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/confirm.vue')
  },
  { //团检切换备选项目
    name: 'teamSwitchover',
    path: '/team/switchover',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/switchover.vue')
  },
  { //团检切换x项目
    name: 'teamChecked',
    path: '/team/Checked',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/project.vue')
  },
  { //团检提交订单
    name: 'teamSubmit',
    path: '/team/submit',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/submit.vue')
  },
  { //团检提交订单成功
    name: 'teamSuccess',
    path: '/team/success',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/success.vue')
  },
  { //团检提交订单成功
    name: 'teamSubmitPack',
    path: '/team/submit/pack',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/team/submitPack.vue')
  },
  { //问诊记录list
    name: 'questionRecordList',
    path: '/questionRecord/list',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/questionRecord/list.vue')
  },
  { //服务卡问卷查看
    name: 'specialQuestion',
    path: '/specialQuestion/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/checkQuestion.vue')
  },
  { //专病专栏
    name: 'specialDisease',
    path: '/specialDisease/list',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/list.vue')
  },
  { //专病专栏
    name: 'diseaseIndex',
    path: '/specialDisease/disease',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/disease.vue')
  },
  { //专病专栏 详情（新）
    name: 'diseaseDetail',
    path: '/specialDisease/detail/:id/:knowledgeId',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/detail.vue')
  },
  { //专病专栏 评估
    name: 'diseaseStartAssess',
    path: '/specialDisease/start/assess/:id/:knowledgeId',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/startAssess.vue')
  },
  { //专项体检
    name: 'physicalSpecial',
    path: '/physical/special/list/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/physicalSpecial.vue')
  },
  { //专项体检 详情
    name: 'physicalSpecialDetail',
    path: '/physical/special/detail/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/physicalSpecialDetail.vue')
  },
  { //专项体检 详情 支付
    name: 'payPhsicalCard',
    path: '/physicalSpecialPay/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/payPhsicalCard.vue')
  },
  { //专项体检 详情 支付
    name: 'payQrPhsicalCard',
    path: '/physical/special/payQr/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/qrCodePay.vue')
  },
  { //专项体检体检卡购买成功展示
    name: 'phsicalCardPaySuccess',
    path: '/physical/special/success/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/success.vue')
  },
  { //专病专栏 历史
    name: 'diseaseHistoryAssess',
    path: '/specialDisease/history/assess/:id/:knowledgeId',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/historyAssess.vue')
  },
  { //专病专栏
    name: 'newDiseaseRegister',
    path: '/specialDisease/new/register/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/question/registerInfo.vue')
  },
  { //专病问卷
    name: 'newDiseaseQuestion',
    path: '/specialDisease/new/question/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/question/question.vue')
  },
  { //专病专栏
    name: 'diseaseRegister',
    path: '/specialDisease/register/:source',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/registerInfo.vue')
  },
  { //专病问卷
    name: 'diseaseQuestion',
    path: '/specialDisease/question/:source',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/question.vue')
  },
  { //专病结果
    name: 'diseaseResult',
    path: '/specialDisease/result/:source',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/specialDisease/result.vue')
  },
  { //家庭成员列表
    name: 'familyList',
    path: '/family/list',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/family/list.vue')
  },
  { //新增家庭成员
    name: 'familyAdd',
    path: '/family/add',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/family/add.vue')
  },
  { //体检报告列表
    name: 'reportList',
    path: '/report/list',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/report/list.vue')
  },
  { //体检报告增加领取人
    name: 'addReportFamily',
    path: '/report/addFamily',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/report/addFamily.vue')
  },
  { //体检报告详情
    name: 'reportDetail',
    path: '/report/detail/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/report/detail.vue')
  },
  { //趋势图
    name: 'reportTendency',
    path: '/report/tendency/:id',
    meta: {
      hiddenHead: true,
      title: '报告分析'
    },
    component: () => import('@/views/report/tendency.vue')
  },
  { //健康管理报告
    name: 'reportHealth',
    path: '/report/health/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/report/health.vue')
  },
  { //管理平台登录
    name: 'platformLogin',
    path: '/platform/login/:platformUserCode/:u/:p/:uri',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/platform/login.vue')
  },
  { //体检卡列表
    name: 'medicalCardList',
    path: '/medicalCard/list',
    meta: {
      menuBar: true,
      hiddenHead: true
    },
    component: () => import('@/views/medicalCard/list.vue')
  },
  { //体检卡详情
    name: 'medicalCardDetail',
    path: '/medicalCard/detail/:id',
    meta: {
      hiddenHead: true
    },
    component: () => import('@/views/medicalCard/detail.vue')
  },
  { // 个人中心购买记录
    name: 'purchaseRecordList',
    path: '/purchase/record/list',
    meta: {
      menuBar: true,
      hiddenHead: true,
      title: '购买记录'
    },
    component: () => import('@/views/purchase/record/list.vue')
  },
  { // 个人中心购买记录详情
    name: 'purchaseRecordDetail',
    path: '/purchase/record/detail/:id',
    meta: {
      hiddenHead: true,
      title: '查看购买记录'
    },
    component: () => import('@/views/purchase/record/detail.vue')
  },
  { // 个人中心电子券list
    name: 'electronicCouponList',
    path: '/electronicCoupon/list',
    meta: {
      menuBar: true,
      hiddenHead: true,
      title: '电子券'
    },
    component: () => import('@/views/electronicCoupon/list.vue')
  },
  { // 个人中心电子券list
    name: 'electronicCouponDetail',
    path: '/electronicCoupon/detail/:id/:couponType',
    meta: {
      hiddenHead: true,
      title: '电子券'
    },
    component: () => import('@/views/electronicCoupon/detail.vue')
  },
  {name: '404', path: '/*', component: NotFoundComponent}
]
